export class TypeProject {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}

export class TypeProjectForm {
    id: number;
    name: string;
    abbreviation: string;
    observation: string;

    constructor() { }
}